//TODO:develop branchから新たな形式をmerge
import client from './client'
import { AxiosPromise } from 'axios'

export const healthCheck = (): AxiosPromise<void> => client.get('/')
